<template>
 <div class="createAction">
   <main class="t-main">
   <ol class="m-breadcrumb">
     <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/delivery/list-action">アクション一覧</router-link></li>
     <li class="m-breadcrumb__item"><span class="a-text">アクション登録</span></li>
   </ol>
  <h1 class="a-title">{{ createActionTitle }}</h1>
  <div class="m-form__item-wrapper">
    <div class="m-form__item m-form__item--50">
      <label class="m-form__label">actionId<span class="m-form__label--necessary">※必須</span>
        <input class="m-form__input m-form__input--text" type="text"　v-model="tasks.actionId" placeholder="例：test01">
      </label>
    </div>
  </div>
  <div class="m-form__item-wrapper">
    <div class="m-form__item m-form__item--50">
      <label class="m-form__label">タイトル<span class="m-form__label--necessary">※必須</span>
        <input class="m-form__input m-form__input--text" type="text" placeholder="例：test" v-model="tasks.metadata.name">
      </label>
    </div>
  </div>
  <div class="m-form__item-wrapper">
    <div class="m-form__item m-form__item--50">
      <label class="m-form__label">アクションタイプ<span class="m-form__label--necessary">※必須</span><span class="m-form__input--select-wrapper">
          <select class="m-form__input m-form__input--select" name="category" v-model="tasks.metadata.type" @change="changeActionType">
            <option value="" disabled>--選択してください--</option>
            <option v-for="actiontype in actiontypes" v-bind:value="actiontype">{{ actiontype }}</option>
          </select></span></label>
    </div>
  </div>
  <div v-if="tasks.metadata.type==='popup'">
    <div class="m-form__item-wrapper">
      <div class="m-form__item m-form__item--50">
        <label class="m-form__label">LINKURL<span class="m-form__label--necessary">※必須</span>
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：https://test.jp/test" v-model="tasks.configuration.url">
        </label>
      </div>
    </div>
    <div class="m-form__item-wrapper">
      <div class="m-form__item m-form__item--50">
        <label class="m-form__label">バナー画像<span class="m-form__label--necessary">※必須</span>
          <input class="m-form__input m-form__input--file" type="file" @change="onFileChange">
        </label>
      </div>
      <div class="m-form__item m-form__item--50">
        <img v-show="uploadedImage" :src="uploadedImage" width="30%"/>
        <button v-if="tasks.model!=''" class="m-form__delete" v-on:click="deleteImage">delete</button>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示位置設定（横方向）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">左右
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.widthType" >
              <option value="" disabled>--選択してください--</option>
              <option value="left">left</option>
              <option value="right">right</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.widthUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="0" placeholder="width" v-model="tasks.configuration.positionConfiguration.width">
        </label>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示位置設定（縦方向）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">上下
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.heightType" >
              <option value="" disabled>--選択してください--</option>
              <option value="top">top</option>
              <option value="bottom">bottom</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.heightUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="0" placeholder="height" v-model="tasks.configuration.positionConfiguration.height">
        </label>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示サイズ設定（幅）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.size.widthUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="1" placeholder="width" v-model="tasks.configuration.size.width">
        </label>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示サイズ設定（高さ）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.size.heightUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="1" placeholder="height" v-model="tasks.configuration.size.height">
        </label>
      </div>
    </div>
    <p class="a-button__wrapper">
      <button class="a-button" v-on:click="createAction">登録</button>
      <button class="a-button a-button--cansel" v-on:click="goListAction">キャンセル</button>
    </p>
  </div>
  <div v-if="tasks.metadata.type==='recommend-ai'">
    <div class="m-form__item-wrapper">
      <div class="m-form__item m-form__item--50">
        <label class="m-form__label">アクションで使用するシナリオのscenarioId<span class="m-form__label--necessary">※必須</span>
          <span class="m-form__input--select-wrapper">
          <select class="m-form__input m-form__input--select" v-model="tasks.configuration.scenarioId" >
            <option value="" disabled>--選択してください--</option>
            <option v-for="scenario in scenarioList" v-bind:value="scenario.scenarioId">{{ scenario.scenarioId }}</option>
          </select>
        </span>
        </label>
      </div>
    </div>
    <p class="a-button__wrapper">
      <button class="a-button" v-on:click="createAction">登録</button>
      <button class="a-button a-button--cansel" v-on:click="goListAction">キャンセル</button>
    </p>
  </div>
  <div v-if="tasks.metadata.type==='icon'">
    <div class="m-form__item-wrapper">
      <div class="m-form__item m-form__item--50">
        <label class="m-form__label">アイコン画像<span class="m-form__label--necessary">※必須</span>
          <input class="m-form__input m-form__input--file" type="file" @change="onFileChange">
        </label>
      </div>
      <div class="m-form__item m-form__item--50">
        <img v-show="uploadedImage" :src="uploadedImage" width="30%"/>
        <button v-if="tasks.model!=''" class="m-form__delete" v-on:click="deleteImage">delete</button>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示位置設定（横方向）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">左右
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.widthType" >
              <option value="" disabled>--選択してください--</option>
              <option value="left">left</option>
              <option value="right">right</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.widthUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="0" placeholder="width" v-model="tasks.configuration.positionConfiguration.width">
        </label>
      </div>
    </div>
    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">表示位置設定（縦方向）</h2>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">上下
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.heightType" >
              <option value="" disabled>--選択してください--</option>
              <option value="top">top</option>
              <option value="bottom">bottom</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item m-form__item--20">
        <label class="m-form__label">単位
          <span class="m-form__input--select-wrapper">
            <select class="m-form__input m-form__input--select" v-model="tasks.configuration.positionConfiguration.heightUnits" >
              <option value="" disabled>--選択してください--</option>
              <option value="px">px</option>
              <option value="%">%</option>
            </select></span>
       </label>
      </div>
      <div class="m-form__item">
        <label class="m-form__label">数値
          <input class="m-form__input m-form__input--text" type="number" min="0" placeholder="height" v-model="tasks.configuration.positionConfiguration.height">
        </label>
      </div>
    </div>

    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">ボットスタイル設定</h2>
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">テキストカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.textColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.textColor }" type="color" class="box" v-model="tasks.configuration.textColor">
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">テキストリンクカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.textLinkColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.textLinkColor }" type="color" class="box" v-model="tasks.configuration.textLinkColor">
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">吹き出しカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.textBackground">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.textBackground }" type="color" class="box" v-model="tasks.configuration.textBackground">
    </div>

    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">ユーザスタイル設定</h2>
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">テキストカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.userTextColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.userTextColor }" type="color" class="box" v-model="tasks.configuration.userTextColor">
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">吹き出しカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.userTextBackground">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.userTextBackground }" type="color" class="box" v-model="tasks.configuration.userTextBackground">
    </div>

    <div class="m-form__item-wrapper" >
      <h2 class="a-title a-title--sub">ボタンスタイル設定</h2>
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">ボタンカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.buttonColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.buttonColor }" type="color" class="box" v-model="tasks.configuration.buttonColor">
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">テキストカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.buttonTextColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.buttonTextColor }" type="color" class="box" v-model="tasks.configuration.buttonTextColor">
      <div class="m-form__item m-form__item--15">
        <label class="m-form__label">ボタンエリアカラー
          <input class="m-form__input m-form__input--text" type="text" placeholder="例：#111111" v-model="tasks.configuration.buttonAreaColor">
        </label>
      </div>
      <input v-bind:style="{ backgroundColor: tasks.configuration.buttonAreaColor }" type="color" class="box" v-model="tasks.configuration.buttonAreaColor">
    </div>
    <p class="a-button__wrapper">
      <button class="a-button" v-on:click="createAction">登録</button>
      <button class="a-button a-button--cansel" v-on:click="goListAction">キャンセル</button>
    </p>
  </div>
</main>
 </div>
</template>

<script>
import store from '../../../stores'
import { includes } from 'lodash'
import { regexp, numberRegexp, actiontypes, ICON, POPUP, UPLOAD_ICON_LIMITATION, UPLOAD_POPUP_LIMITATION } from '../../../constants'

export default {
  name: 'createAction',
  data() {
    return {
      createActionTitle: 'アクション登録',
      actiontypes
    }
  },
  created() {
    store.dispatch('formatActionData')
    store.dispatch('getScenarioList')
  },
  computed: {
    tasks: { get() { return store.state.action.action } },
    scenarioList: { get() { return store.state.action.scenarioList } },
    uploadedImage: { get() { return store.state.action.uploadedImage } },
    // バリデーション関数を定義する
    validation: function () {
      return {
        actionId: regexp.test(this.tasks.actionId),
        name: !!this.tasks.metadata.name.trim(),
        actiontype: !!this.tasks.metadata.type.trim(),
        url: ((this.tasks.metadata.type === 'popup' && !!this.tasks.configuration.url.trim()) || this.tasks.metadata.type === 'recommend-ai' || this.tasks.metadata.type === 'icon')
      }
    },
    // バリデーションを読み込む関数
    isValid: function () {
      let msg = []
      if (this.tasks.actionId === '') {
        msg.push('actionIdは必須です')
      } else if (this.validation.actionId === false) {
        msg.push('入力項目(actionId)に不備があります')
      }
      if (this.validation.name === false) {
        msg.push('タイトルは必須です')
      }
      if (this.validation.actionType === false) {
        msg.push('アクションタイプは必須です')
      }
      if (this.validation.url === false) {
        msg.push('URLは必須です')
      }
      if (this.tasks.configuration.type === 'recommend-ai') {
        if (this.tasks.configuration.scenarioId == null || this.tasks.configuration.scenarioId === '') {
          msg.push('scenarioIdは必須です')
        }
      }
      if (this.tasks.configuration.type !== 'recommend-ai' && (this.tasks.model == null || this.tasks.model === '')) {
        msg.push('画像は必須です')
      }
      if (this.tasks.configuration.type === 'popup' || this.tasks.configuration.type === 'icon') {
        if (this.tasks.configuration.positionConfiguration.width !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.width) === false) {
          msg.push('表示位置設定（横方向）の数値に不備があります')
        }
        if (this.tasks.configuration.positionConfiguration.height !== '' && numberRegexp.test(this.tasks.configuration.positionConfiguration.height) === false) {
          msg.push('表示位置設定（縦方向）の数値に不備があります')
        }
      }
      if (this.tasks.configuration.type === 'popup') {
        if (this.tasks.configuration.size.width !== '' && (numberRegexp.test(this.tasks.configuration.size.width) === false || this.tasks.configuration.size.width < 1)) {
          msg.push('表示サイズ設定（幅）の数値に不備があります（1以上）')
        }
        if (this.tasks.configuration.size.height !== '' && (numberRegexp.test(this.tasks.configuration.size.height) === false || this.tasks.configuration.size.height < 1)) {
          msg.push('表示サイズ設定（高さ）の数値に不備があります（1以上）')
        }
      }
      return msg.join('\n')
    }
  },

  methods: {
    createAction: function() {
      var errMsg = this.isValid
      if (errMsg === '') {
        store.dispatch('checkSessionId')
        store.dispatch('createAction', this.$router)
      } else {
        alert(errMsg)
      }
    },
    goListAction: function() {
      this.$router.push('/delivery/list-action')
    },
    changeActionType: function() {
      // configurationを初期化する。
      store.dispatch('formatConfigurationData')
    },
    deleteImage: function() {
      store.dispatch('setModel', { 'model': '', 'modelExtention': '' })
      store.dispatch('setUploadedImage', '')
    },
    onFileChange: function(e) {
      let files = e.target.files || e.dataTransfer.files
      if (files) {
        // base64に変換する
        let fileReader = new FileReader()
        fileReader.onload = function() {
          if (includes(['png', 'jpg', 'jpeg', 'gif'], this.result.split(',')[0].split(';')[0].split('/')[1])) {
            let modelData = { 'model': this.result.split(',')[1], 'modelExtention': this.result.split(',')[0].split(':')[1].split('/')[1].split(';')[0] }
            store.dispatch('setModel', modelData)
            store.dispatch('setUploadedImage', this.result)
          } else {
            alert('画像ファイルは「jpg」「png」「gif」のみ登録可能です。')
            store.dispatch('setModel', { 'model': '', 'modelExtention': '' })
            store.dispatch('setUploadedImage', '')
          }
        }
        if (this.tasks.metadata.type === ICON) {
          if (files[0].size > UPLOAD_ICON_LIMITATION.LIMIT) {
            alert('アイコン画像は' + UPLOAD_ICON_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。')
            store.dispatch('setModel', { 'model': '', 'modelExtention': '' })
            store.dispatch('setUploadedImage', '')
          } else {
            fileReader.readAsDataURL(files[0])
            let img
            img = new Image()
            img.onload = function() {
              if (this.width !== this.height) {
                alert('アイコン画像は縦横比が1:1の画像のみ登録可能です。')
                store.dispatch('setModel', { 'model': '', 'modelExtention': '' })
                store.dispatch('setUploadedImage', '')
              }
            }
            img.src = (window.URL || window.webkitURL).createObjectURL(files[0])
          }
        } else if (this.tasks.metadata.type === POPUP) {
          if (files[0].size > UPLOAD_POPUP_LIMITATION.LIMIT) {
            alert('ポップアップ画像は' + UPLOAD_POPUP_LIMITATION.TEXT + '未満のサイズでのみ登録可能です。')
            store.dispatch('setModel', { 'model': '', 'modelExtention': '' })
            store.dispatch('setUploadedImage', '')
          } else {
            fileReader.readAsDataURL(files[0])
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/action/CreateAction.vue